import { useEffect } from 'react';

/** I caratteri dello stile «Sinapsi», da Google Fonts, una volta sola; senza rete restano quelli di sistema. */
export function useSinapsiFonts() {
  useEffect(() => {
    if (document.getElementById('tm-fonts')) return;
    const l = document.createElement('link');
    l.id = 'tm-fonts';
    l.rel = 'stylesheet';
    l.href =
      'https://fonts.googleapis.com/css2?family=Unbounded:wght@400;600;800&family=JetBrains+Mono:wght@400;500;600&display=swap';
    document.head.appendChild(l);
  }, []);
}
